<form [formGroup]="frmComm">
  <div class="grid">
    <div class="col-12 md:col-6">
      <label>Nome*</label>
      <div class="mt-1">
        <input type="text" pInputText class="w-full" formControlName="name" />
        @if (frmComm.get("name")?.errors && frmComm.get("name")?.dirty) {
          <st-errors [errors]="frmComm.get('name')?.errors"></st-errors>
        }
      </div>
    </div>
    <div class="col-12 md:col-6">
      <label>Tipo di gruppo</label>
      <div class="selectButton mt-1">
        <p-selectButton
          [options]="type"
          formControlName="public"
          optionLabel="name"
          optionValue="value"
          styleClass="w-full"
        ></p-selectButton>
      </div>
      @if (frmComm.get("public")?.errors && frmComm.get("public")?.dirty) {
        <st-errors [errors]="frmComm.get('public')?.errors"></st-errors>
      }
    </div>
    <div class="col-12">
      <label class="mb-3">Tags</label>
      <div class="w-full mt-1 block">
        <p-chips formControlName="tags" [max]="5"></p-chips>
      </div>
    </div>
    <div class="col-12">
      <label class="mb-3">Descrizione</label>
      <textarea
        rows="5"
        pInputTextarea
        class="w-full mt-1"
        formControlName="text"
      ></textarea>
    </div>

    <div class="w-full flex align-items-center justify-content-center mt-2">
      <div>
        @if (img) {
          <div
            class="community-img flex align-items-center justify-content-center"
          >
            <img class="w-full" [src]="img | imagePipe: 'user' : 'lg'" />
          </div>
        }
        <!-- @if(!isUpdate){ -->
        <input
          type="file"
          (change)="fileChangeEvent($event)"
          id="image"
          style="display: none"
        />
        <div class="my-4">
          <label for="image" class="label block"> Scegli un'immagine </label>
        </div>
        <!-- } -->
      </div>
    </div>

    <!-- @if(!isUpdate){ -->
    <div class="mt-3">
      <div class="grid">
        <div class="col-6">
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded($event)"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
          ></image-cropper>
        </div>
        <div class="col-6">
          <img class="w-full" [src]="croppedImage" />
        </div>
      </div>
    </div>
    <!-- } -->
  </div>
</form>

<div class="modal-footer flex justify-content-between">
  <div class="w-full">
    <p-button
      label="Annulla"
      size="small"
      (click)="close()"
      [outlined]="true"
    ></p-button>
  </div>
  <div class="w-full ml-3">
    <p-button
      label="Salva"
      size="small"
      (click)="save()"
      styleClass="slide-o"
      [disabled]="frmComm.invalid"
    ></p-button>
  </div>
</div>
